import { useKeycloak } from "@react-keycloak/web";
import { Fragment, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../app/store";
import useAuth from "../hooks/useAuth";
import { Role } from "../types";
import Loader from "./ui/Loader";

interface PrivateRouteProps {
  children: ReactNode;
  roles: Role[];
}

export default function PrivateRoute({ children, roles }: PrivateRouteProps) {
  const isAuth = useAuth(roles);
  const { keycloak, initialized } = useKeycloak();
  const { access_token } = useAppSelector((state) => state.auth);

  // Wait for Keycloak to initialize
  if (!initialized) {
    return <Loader />;
  }

  // Keep app session when Redux/local token exists, even if Keycloak runtime
  // state is momentarily out of sync after profile/email updates.
  if (isAuth && (Boolean(access_token) || keycloak.authenticated || keycloak.token)) {
    return <Fragment>{children}</Fragment>;
  }

  return <Navigate to="/sign-in" />;
}
